import { addBootTiming } from 'owa-performance';
export function removeLoader() {
    const loader = document.getElementById('loadingScreen');
    if (loader?.parentNode === document.body) {
        addBootTiming('ls_e');
        document.body.removeChild(loader);
    }
}
